var ReturnPage = {};

ReturnPage.returnFields = [
  {name: "returnReason", required: true},
  {name: "fname", required: true},
  {name: "lname", required: true},
  {name: "phone", required: true},
  {name: "email", required: true},
  {name: "returnType", required: true},
  {name: "deliveryFirstName", required: true},
  {name: "deliveryLastName", required: true},
  {name: "deliveryPhone", required: true},
  {name: "deliveryStreet", required: true},
  {name: "deliveryHouseNumber", required: true},
  {name: "deliveryZip", required: true},
  {name: "deliveryCity", required: true},
  {name: "acceptance", required: true},
  {name: "deliveryMethod", required: true}
];

ReturnPage.reclamationFields = [
  {name: "reclamationReason", required: true},
  {name: "fname", required: true},
  {name: "lname", required: true},
  {name: "phone", required: true},
  {name: "email", required: true},
  {name: "deliveryFirstName", required: true},
  {name: "deliveryLastName", required: true},
  {name: "deliveryPhone", required: true},
  {name: "deliveryStreet", required: true},
  {name: "deliveryHouseNumber", required: true},
  {name: "deliveryZip", required: true},
  {name: "deliveryCity", required: true},
  {name: "acceptance", required: true},
  {name: "deliveryMethod", required: true}
];

ReturnPage.init = function () {
  $('.refunds-complaints .expand a').click(function () {
    $(this).parents('.table-body > .item').remove();
    if (!$('.table-body > .item').length) {
      return location.href = "/moje-zamowienia";
    }
  });

  $('input[name=returnReason], input[name=reclamationReason]').click(function () {
    if (this.id === 'returnReasonOther' || this.id === 'reclamationReasonOther') {
      $('input[name=otherReason]').parent().show();
    } else {
      $('input[name=otherReason]').parent().hide();
    }
  });

  $('input[name=reclamationSolution]').click(function () {
    if (this.id === 'reclamationSolutionOther') {
      $('input[name=otherSolution]').parent().show();
    } else {
      $('input[name=otherSolution]').parent().hide();
    }
  });

  $('input[name=returnType], input[name=reclamationSolution]').click(function () {
    if ($(this).attr('data-options')) {
      var options = JSON.parse($(this).attr('data-options'));
      var showBankDetailsInputs = false;
      for (var i = 0; i < options.length; i++) {
        if (options[i].key === 'askForBankDetails' && options[i].value === 'true') {
          showBankDetailsInputs = true;
        }
      }
      if (showBankDetailsInputs) {
        return $('.bank-details').removeClass('hidden');
      }
    }
    $('.bank-details').addClass('hidden');
  });

  $('button#submit-return-form').click(function (evt) {
    var errors = Forms.validateFields(document.forms.returnForm, ReturnPage.returnFields);
    if (errors.length) {
      $('html').animate({
        scrollTop: $($('.form-error').get(0)).parent().offset().top - 20
      }, 1000);
      return evt.preventDefault();
    }
  });

  $('button#submit-reclamation-form').click(function (evt) {
    var errors = Forms.validateFields(document.forms.reclamationForm, ReturnPage.reclamationFields);
    if (errors.length) {
      $('html').animate({
        scrollTop: $($('.form-error').get(0)).parent().offset().top - 20
      }, 1000);
      return evt.preventDefault();
    }
  });


};

$(ReturnPage.init);